/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiOfficesIdMutationResponse,
  DeleteApiOfficesIdPathParams,
} from '../models/DeleteApiOfficesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiOfficesIdMutationResponseSchema } from '../zod/deleteApiOfficesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiOfficesIdMutationKey = () =>
  [{ url: '/api/offices/:id' }] as const;

export type DeleteApiOfficesIdMutationKey = ReturnType<
  typeof deleteApiOfficesIdMutationKey
>;

/**
 * {@link /api/offices/:id}
 */
export async function deleteApiOfficesId(
  id: DeleteApiOfficesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiOfficesIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/offices/${id}`,
    ...requestConfig,
  });
  return deleteApiOfficesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/offices/:id}
 */
export function useDeleteApiOfficesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiOfficesIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiOfficesIdPathParams['id'] },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiOfficesIdMutationKey();

  return useMutation<
    DeleteApiOfficesIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiOfficesIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiOfficesId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
